// src/contexts/SearchContext.js
import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const SearchContext = createContext();

export const useSearch = () => {
  return useContext(SearchContext);
};

export const SearchProvider = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const updateSearchQuery = useCallback((query) => {
    setSearchQuery(query);
  }, []);

  const value = useMemo(
    () => ({ searchQuery, updateSearchQuery }),
    [searchQuery, updateSearchQuery]
  );

  return (
    <SearchContext.Provider value={value}>{children}</SearchContext.Provider>
  );
};
